"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const IconWrapper_styled_1 = require("./IconWrapper.styled");
const IconWrapper_types_1 = require("./IconWrapper.types");
const IconWrapper = ({ size = IconWrapper_types_1.IconSize.Medium, color = IconWrapper_types_1.IconColor.DigitalBlack, viewBox, className, onClick }, icon) => {
    const theme = (0, react_1.useContext)(styled_components_1.ThemeContext) || malty_theme_malty_theme_provider_1.globalTheme;
    const [numSize, setNumSize] = (0, react_1.useState)(theme.sizes.m.value);
    const [iconColor, setIconColor] = (0, react_1.useState)(theme.colors.colours.default['digital-black'].value);
    (0, react_1.useEffect)(() => {
        setNumSize(theme.sizes[size].value);
    }, [size, theme]);
    (0, react_1.useEffect)(() => {
        if (color === IconWrapper_types_1.IconColor.Alert ||
            color === IconWrapper_types_1.IconColor.AlertLight ||
            color === IconWrapper_types_1.IconColor.DisableDark ||
            color === IconWrapper_types_1.IconColor.DisableLight ||
            color === IconWrapper_types_1.IconColor.Fail ||
            color === IconWrapper_types_1.IconColor.FailLight ||
            color === IconWrapper_types_1.IconColor.Notification ||
            color === IconWrapper_types_1.IconColor.NotificationLight ||
            color === IconWrapper_types_1.IconColor.Success ||
            color === IconWrapper_types_1.IconColor.SuccessLight) {
            return setIconColor(theme.colors.colours.system[color].value);
        }
        if (color === IconWrapper_types_1.IconColor.Support20 ||
            color === IconWrapper_types_1.IconColor.Support40 ||
            color === IconWrapper_types_1.IconColor.Support60 ||
            color === IconWrapper_types_1.IconColor.Support80 ||
            color === IconWrapper_types_1.IconColor.Support100) {
            return setIconColor(theme.colors.colours.support[color].value);
        }
        if (color === IconWrapper_types_1.IconColor.Primary || color === IconWrapper_types_1.IconColor.Secondary || color === IconWrapper_types_1.IconColor.Tertiary) {
            return setIconColor(theme.colors.theme[color].value);
        }
        return setIconColor(theme.colors.colours.default[color].value);
    }, [color, theme]);
    return (react_1.default.createElement(IconWrapper_styled_1.StyledIcon, { viewBox: viewBox !== null && viewBox !== void 0 ? viewBox : '0 0 24 24', className: className, color: iconColor, size: numSize, onClick: onClick, theme: theme, "data-testid": "svg-component" }, icon));
};
exports.default = IconWrapper;
//# sourceMappingURL=IconWrapper.js.map